import * as React from 'react';

// ICONS
import { ReactComponent as SuccessIcon } from '../assets/svg/status-success.svg';
import { ReactComponent as WarningIcon } from '../assets/svg/status-warning.svg';
import { ReactComponent as DangerIcon } from '../assets/svg/status-danger.svg';
import { ReactComponent as ArchivedIcon } from '../assets/svg/status-archived.svg';
import { ReactComponent as ReadIcon } from '../assets/svg/status-read.svg';
import { ReactComponent as TodoIcon } from '../assets/svg/status-todo.svg';
import { ReactComponent as TrainingPlusIcon } from '../assets/svg/status-training-plus.svg';
import { ReactComponent as DocumentIcon } from '../assets/svg/status-document.svg';
import { ReactComponent as SchoolIcon } from '../assets/svg/status-school.svg';
import { ReactComponent as CommunityIcon } from '../assets/svg/status-community.svg';
import { ReactComponent as BusinessIcon } from '../assets/svg/status-business.svg';

interface StatusIconTypes {
	statusType: string;
	width?: number;
	height?: number;
}

const StatusIcon: React.FC<StatusIconTypes> = ({ statusType, width, height }) => {
	const iconProps =
		width && height
			? { width, height }
			: { className: 'status-icon', ...(width ? { width } : {}), ...(height ? { height } : {}) };

	return (
		<>
			{statusType === 'success' && <SuccessIcon {...iconProps} />}
			{statusType === 'Success' && <SuccessIcon {...iconProps} />}

			{statusType === 'warning' && <WarningIcon {...iconProps} />}
			{statusType === 'Warning' && <WarningIcon {...iconProps} />}

			{statusType === 'danger' && <DangerIcon {...iconProps} />}
			{statusType === 'Error' && <DangerIcon {...iconProps} />}

			{statusType === 'archived' && <ArchivedIcon {...iconProps} />}
			{statusType === 'read' && <ReadIcon {...iconProps} />}
			{statusType === 'todo' && <TodoIcon {...iconProps} />}
			{statusType === 'training' && <TodoIcon {...iconProps} />}
			{statusType === 'training-plus' && <TrainingPlusIcon {...iconProps} />}
			{statusType === 'document' && <DocumentIcon {...iconProps} />}
			{statusType === 'school' && <SchoolIcon {...iconProps} />}
			{statusType === 'community' && <CommunityIcon {...iconProps} />}
			{statusType === 'business' && <BusinessIcon {...iconProps} />}
		</>
	);
};

export default StatusIcon;
